import { getSessionCookies, SessionCookies } from "./sessionCookies";

import config from "../../../../../config/app";
import { getQuoteURL } from "../../../cikmcl/helpers";

const { appName, appVersion, pageViewServiceUrl } = config;

interface GoogleAnalyticsData {
  clientId: string;
}

interface SnowPlowData {
  clientUserId: string;
  cookieCreatedAt: string;
  currentVisit: string;
  domainUserId: string;
  isFirstSession: boolean;
  lastVisit: string;
  sessionId: string;
  visitCount: number;
}

export interface Attribution {
  app: {
    name: string;
    version: string;
  };
  brandName: string;
  browser?: {
    name: string;
    version: string;
  };
  compara: SessionCookies;
  countryCode: string;
  formURL: string;
  ga?: GoogleAnalyticsData;
  ip?: string;
  modelName: string;
  modelYear: number;
  os?: string;
  pageURL: string;
  platform?: string;
  referrer: string;
  snowplow?: SnowPlowData;
  timeStamp: string;
  utm?: unknown;
}

export interface BuildAttributionProps {
  formId: string;
  isSOAPCrossSelling?: boolean;
}

export type BuildAttribution = (data: BuildAttributionProps) => Promise<Attribution>;

async function getAttributionFromService(): Promise<Attribution> {
  const response = await fetch(pageViewServiceUrl.first, {
    headers: { "Content-Type": "application/json" },
    method: "POST"
  });
  return response ? response.json() : {};
}
export function getGoogleAnalyticsData(): GoogleAnalyticsData | undefined {
  let gaData;
  if (!window.ga) return gaData;

  window.ga((tracker: { get: (attr: string) => string }) => {
    gaData = { clientId: tracker.get("clientId") };
  });

  return gaData;
}

function toISOString(timestamp: number): string {
  const SECOND_AS_MILLISECOND = 1000;
  return new Date(timestamp * SECOND_AS_MILLISECOND).toISOString();
}

function getSnowPlowData(isSOAPCrossSelling: boolean): SnowPlowData | undefined {
  let snowPlowData;
  if (!window.co_snowplow) return snowPlowData;

  window.co_snowplow(function() {
    const FIRST_SESSION_VALUE = "1";
    const user = this.cf;
    if (!user) return;

    const clientUserId = user.getUserId();
    const [
      isFirstSession,
      domainUserId,
      cookieCreatedAt,
      visitCount,
      currentVisit,
      lastVisit,
      sessionId
    ] = user.getDomainUserInfo();

    snowPlowData = {
      clientUserId,
      domainUserId,
      sessionId,
      visitCount,
      cookieCreatedAt: toISOString(cookieCreatedAt),
      currentVisit: toISOString(currentVisit),
      isFirstSession: isFirstSession === FIRST_SESSION_VALUE,
      lastVisit: toISOString(lastVisit),
      isSOAPCrossSelling
    };
  });

  return snowPlowData;
}

export const buildAttribution: BuildAttribution = async ({
  formId,
  isSOAPCrossSelling = false
}) => ({
  ...(await getAttributionFromService()),
  app: {
    name: appName,
    version: appVersion
  },
  compara: getSessionCookies(),
  countryCode: "cl",
  ga: getGoogleAnalyticsData(),
  pageURL: getQuoteURL(formId),
  formURL: getQuoteURL(formId),
  referrer: isSOAPCrossSelling ? "soap-cross-selling" : document.referrer,
  snowplow: getSnowPlowData(isSOAPCrossSelling),
  timeStamp: new Date().toISOString()
});
